import { Head } from "@inertiajs/react";
import { t } from "@travily/i18n";
import type FavoritesProgramsIndex from "@travily/types/pages/FavoritesProgramsIndex";
import { useFavoritesTabs } from "@/hooks/use-favorites-tabs";
import { usePageFavorites } from "@/hooks/use-search-favorites";
import { PageFrame } from "@/layouts/page-frame";
import { FavoritesFrame } from "@/pages/favorites/components/FavoritesFrame";
import { ProgramFavorites } from "./programs.view";

const FavoritesProgramsPage = ({ programs }: FavoritesProgramsIndex) => {
  const { getFavorited, onFavoriteToggle } = usePageFavorites();
  const tabs = useFavoritesTabs();

  return (
    <PageFrame>
      <Head title={t("web.favorites.programs.meta_title")} />
      <FavoritesFrame currentTab="programs" tabs={tabs} title={t("web.favorites.index.title")}>
        <ProgramFavorites
          empty={{
            description: t("web.favorites.index.empty.programs.description"),
            title: t("web.favorites.index.empty.programs.title"),
          }}
          getFavorited={getFavorited}
          onFavoriteToggle={onFavoriteToggle}
          programs={programs}
        />
      </FavoritesFrame>
    </PageFrame>
  );
};

export default FavoritesProgramsPage;
